module.exports = __webpack_public_path__ + "static/media/homeowners_new.56602387.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/homeowners_new.svg
// module id = 3198
// module chunks = 0